import $c from '@/services/api/lib/container'

export default {
  loadStores () {
    return $c.get('stores').get()
  },

  async loadZones () {
    return $c.get('zones').get()
  },

  loadTerritories () {
    return $c.get('territories').get()
  },

  loadTaxRates () {
    return $c.get('taxRates').get()
  },

  loadTaxGroups () {
    return $c.get('taxGroups').get()
  },

  async loadShippingMethods (data) {
    let _sortBy = data.descending ? '-' : ''
    _sortBy += data.sortBy

    return $c.get('shipping')
      .page(data.page || 1)
      .limit(data.rowsPerPage || 25)
      .orderBy(_sortBy)
      .getFullData()
  },

  async loadPaymentMethods () {
    return $c.get('paymentMethods').get()
  },

  async loadAbilities () {
    let response = await $c.get('abilities').get()
    return response[0] || response
  }
}
